import {type AstPosition, type EnrichedAstNode, type AstView} from '../../../rendition-core';
import _ from 'lodash';
import axios from 'axios';
// const syncServiceUrl = 'http://localhost:3010/rast';
const syncServiceUrl = 'https://doc-sync-engine-dot-rendition-prod.wl.r.appspot.com/rast'; // This should be stable enough for everyone.;
export async function syncViewToSimulatedV2(view: AstView) {
    // call api and get dictionary

    const result = await axios.post(syncServiceUrl, view);

    const newPositions: {[key: string]: AstPosition} = result.data;

    syncSimulationToInternalV2(view.tree, newPositions);
    return view;
}

export const getSyncServiceScreenshot = async (width: number, height: number, html: string) => {
    try {
        const body = {screenSize: {width, height}, html};
        const result = await axios.post<{screenshot: string; successfulRender: boolean}>(
            syncServiceUrl + '/screenshot',
            body
        );

        return result.data;
    } catch (e) {
        console.error(e);
        return {screenshot: '', successfulRender: false};
    }
};

export function syncSimulationToInternalV2(node: EnrichedAstNode, dictionary: {[key: string]: AstPosition}) {
    const newPosition = dictionary[node.internalId];
    if (newPosition) {
        sync(node, newPosition);
    }
    if (node.type === 'Text') {
        // text children and not position calculated so can return.
        return;
    }

    node.children.forEach((child) => {
        syncSimulationToInternalV2(child, dictionary);
    });
}

function sync(node: EnrichedAstNode, newPosition: AstPosition) {
    ['absoluteX', 'absoluteY', 'height', 'width'].forEach((key) => {
        if (Math.round(node.position[key]) !== Math.round(newPosition[key])) {
            console.log('failed', key, Math.round(node.position[key]), Math.round(newPosition[key]));
        }
    });

    node.position.absoluteX = newPosition.absoluteX;
    node.position.absoluteY = newPosition.absoluteY;
    node.position.height = newPosition.height;
    node.position.width = newPosition.width;
}

export async function measureNode(node: EnrichedAstNode, view: AstView) {
    const tempView = _.cloneDeep(view);

    tempView.tree = node;
    try {
        const result = await axios.post(syncServiceUrl + '/measure', {view: tempView, width: 2000, height: 2000});
        const newPositions: {[key: string]: AstPosition} = result.data;
        return newPositions[node.internalId];
    } catch (e) {
        console.log(e);
        return node.position;
    }
}
